import { Component, OnInit, Inject, AfterViewInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";

import { TranslateService } from "@ngx-translate/core";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";

@Component({
    selector: "app-share-dialog",
    templateUrl: "./share-dialog.component.html",
    styleUrls: ["./share-dialog.component.scss"],
})
export class ShareDialogComponent implements OnInit, AfterViewInit {
    lang: any;
    url_share = "";
    public config: SwiperConfigInterface = {};
    encodeUrlName: any;
    environmentVariables: any;
    constructor(
        public dialogRef: MatDialogRef<ShareDialogComponent>,
        private confgServ: StaticPagesService,
        public embryoService: EmbryoService,
        public snackBar: MatSnackBar,
        private translate: TranslateService,
        @Inject(MAT_DIALOG_DATA) public product: any
    ) {
        this.getInitilizingData();
        this.embryoService.emitLang.subscribe((item: any) => {
            translate.setDefaultLang(item);
            this.lang = item;
        });
        this.encodeUrlName = encodeURI(this.product.name);
    }

    ngOnInit() {
        this.lang = localStorage.getItem("lang");
    }
    getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res) => {
            this.environmentVariables = res;

            this.url_share = this.environmentVariables?.WEBSITE_URL || "";
        });
    }

    shareWithFB(product?: any) {
        const left = screen.width / 2 - 500 / 2;
        const top = screen.height / 2 - 500 / 2;
        window.open(
            "http://www.facebook.com/sharer.php?t=" +
                product.name +
                "&u=" +
                product.share_link,
            "sharer",
            "top=" +
                top +
                ",left=" +
                left +
                ",toolbar=0,status=0,width=" +
                500 +
                ",height=" +
                500
        );
    }

    shareWithMessenger(product?: any) {
        const left = screen.width / 2 - 500 / 2;
        const top = screen.height / 2 - 500 / 2;
        window.open(
            "https://www.facebook.com/dialog/send?link=" +
                product.share_link +
                "&app_id=251056675749748" +
                "&redirect_uri=" +
                this.url_share,
            "sharer",
            "top=" +
                top +
                ",left=" +
                left +
                ",toolbar=0,status=0,width=" +
                500 +
                ",height=" +
                500
        );
    }
    shareWithMessengerMobile(product?: any) {
        const left = screen.width / 2 - 500 / 2;
        const top = screen.height / 2 - 500 / 2;
        window.open(
            "fb-messenger://share?link=" +
                product.share_link +
                "&app_id=251056675749748",
            "sharer",
            "top=" +
                top +
                ",left=" +
                left +
                ",toolbar=0,status=0,width=" +
                500 +
                ",height=" +
                500
        );
    }
    shareWithWhatsapp(product?: any) {
        const left = screen.width / 2 - 500 / 2;
        const top = screen.height / 2 - 500 / 2;
        const encodeUrl = encodeURI(product.name);
        window.open(
            "https://web.whatsapp.com/send?text=" + product.share_link,
            "sharer",
            "top=" +
                top +
                ",left=" +
                left +
                ",toolbar=0,status=0,width=" +
                500 +
                ",height=" +
                500
        );
    }
    shareWithWhatsappMobile(product?: any) {
        const left = screen.width / 2 - 500 / 2;
        const top = screen.height / 2 - 500 / 2;
        const encodeUrl = encodeURI(product.name);
        window.open(
            "whatsapp://send?text=" + product.share_link,
            "sharer",
            "top=" +
                top +
                ",left=" +
                left +
                ",toolbar=0,status=0,width=" +
                500 +
                ",height=" +
                500
        );
    }
    shareWithTW(product?: any) {
        const left = screen.width / 2 - 500 / 2;
        const top = screen.height / 2 - 500 / 2;
        const encodeUrl = encodeURI(product.name);

        window.open(
            "https://twitter.com/intent/tweet?text=" +
                product.share_link +
                "&url=" +
                product.share_link +
                "&p  [images][0]=" +
                product.image,
            "sharer",
            "top=" +
                top +
                ",left=" +
                left +
                ",toolbar=0,status=0,width=" +
                500 +
                ",height=" +
                500
        );
    }
    shareWithTWMobile(product?: any) {
        const left = screen.width / 2 - 500 / 2;
        const top = screen.height / 2 - 500 / 2;
        const encodeUrl = encodeURI(product.name);

        window.open(
            "https://twitter.com/intent/tweet?" +
                product.share_link +
                "&p  [images][0]=" +
                product.image,
            "sharer",
            "top=" +
                top +
                ",left=" +
                left +
                ",toolbar=0,status=0,width=" +
                500 +
                ",height=" +
                500
        );
    }
    copyInputMessage(product?: any) {
        // const selectUrl =  'https://http://dev.soleekhub.com/trollyweb/products6571/' + product.id + '/' + product.name;
        const selBox = document.createElement("textarea");
        selBox.style.position = "fixed";
        selBox.style.left = "0";
        selBox.style.top = "0";
        selBox.style.opacity = "0";
        selBox.value = product;
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand("copy");
        document.body.removeChild(selBox);
        if (localStorage.getItem("lang") == "en") {
            this.snackBar.open("Text copied", "×", {
                panelClass: "success",
                verticalPosition: "top",
                duration: 3000,
            });
        } else {
            this.snackBar.open("تم نسخ النص", "×", {
                panelClass: "success",
                verticalPosition: "top",
                duration: 3000,
                direction: "rtl",
            });
        }
    }

    ngAfterViewInit() {
        this.config = {
            slidesPerView: 1,
            spaceBetween: 0,
            keyboard: true,
            navigation: true,
            pagination: false,
            grabCursor: true,
            loop: false,
            preloadImages: false,
            lazy: true,
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
        };
    }

    public close(): void {
        this.dialogRef.close();
    }
}
